export default __webpack_public_path__ + "static/media/i_1.51ad5493.svg";